import { createSelector } from 'reselect';


const selectIsChangeLogin = createSelector(
  state => state.user.update,
  update => !!(update && update.phone),
);

export default selectIsChangeLogin;
